import { createFeatureSelector } from "@ngrx/store";
import { RootKeys } from "./app.model";

export const RootSelectors = {
    REFERENCE_DATA: createFeatureSelector<any>(RootKeys.reference_data),
}